<template>
   <template v-if="d_data.saringan_hantar == 1">
      <div class="grow ">
         <div class="w-flex wrap smd-column" >
           <div class="grow ">
             <table class="table-status">
              <tbody>
               <tr class="row_data">
                  <td><b>  No Kes </b></td>
                  <td><b>:</b></td>
                  <td>
                    <!-- {{form_s.no_kes}} -->
                     <w-tooltip md top color="white" bg-color="black">
                                 <template #activator="{ on }">
                                    <a v-on="on" 
                                       @click="url_kes(form_s.no_kes)" 
                                       style="text-decoration: underline; color: #3a3ad0;">
                                       {{ form_s.no_kes }}
                                    </a>
                                 </template>
                                 <span>
                                    https://myvetlab.dvs.gov.my/myvetlabservis/senarai-keputusan-smartfarming.php?no_kes={{ form_s.no_kes }}
                                 </span>
                              </w-tooltip>
                  </td>
               </tr>
               <tr class="row_data">
                  <td><b>  Ujian Bakteria </b></td>
                  <td><b>:</b></td>
                  <td>{{form_s.ujianBakteria_label}}</td>
               </tr>
               </tbody>
            </table>
              </div>
              <div class="mx2"></div>
              <div class="grow ">
            <table class="table-status">
              <tbody>
               <tr class="row_data">
                  <td><b> Ujian Virus </b></td>
                  <td><b>:</b></td>
                  <td>{{form_s.ujianVirus_label}}</td>
               </tr>
               <tr class="row_data">
                  <td><b>  Keputusan </b></td>
                  <td><b>:</b></td>
                  <td>{{form_s.keputusan_label}}</td>
               </tr>
               </tbody>
            </table>
              </div>
              <div class="mx2"></div>
              <div class="grow ">
            <table class="table-status">
              <tbody>
               <tr class="row_data">
                  <td><b> File PDF </b></td>
                  <td><b>:</b></td>
                   <a v-if="fileCiri2.length > 0" :href="fileCiri2[0].url">{{fileCiri2[0].name}}</a>
               </tr>
               <tr class="row_data">
                  <td><b> Status </b></td>
                  <td><b>:</b></td>
                  <td>{{form_s.status_label}}</td>
               </tr>
                <tr class="row_data">
                  <td><b> Catatan </b></td>
                  <td><b>:</b></td>
                  <td>{{form_s.catatan}}</td>
               </tr>
               </tbody>
            </table>
         </div>
      </div>
   </div> 
</template>
<template v-else>
      <w-form class="" v-model="form_s.valid" v-model:errors-count="form_s.errorsCount" @validate="onValidate" @success="onSuccess()" >
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <w-input class="mt4"  label="No Kes :" type="text" v-model="form_s.no_kes" />
            <z-select class="mt4" :items="status_lg" label="Ujian Bakteria  *" @input="lulus" v-model="form_s.ujian_bakteria_id"  :validators="[validators.required]" />
            <z-select class="mt4" :items="status_lg" label="Ujian Virus  *"  @input="lulus" v-model="form_s.ujian_virus_id"  :validators="[validators.required]" />
            <z-select class="mt4" :items="status_lg" label="Keputusan  *"  v-model="form_s.keputusan_id"  :validators="[validators.required]" readonly/>
          </div>  
          <div class="mx2"></div>
          <div class="grow " >
            <template v-if="$zutil.anyRole(['1', '3', '11']) ">
              <w-input class="mt4" type="file" :preview="false" accept="application/pdf" v-model="files" multiple>Muat Naik File PDF (Keputusan Ujian Saringan Penyakit)</w-input>
              <!-- <template v-for="dt, ind  in attahecment">
                <div class="fw-normal my1 fs-1">  
                  <a :href="dt.url">{{ dt.name }}</a> <w-button  bg-color="error-dark1"  @click="deletelAttahecment(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button>
                </div>
              </template> -->
              <td>
                 <template v-if="fileCiri2.length > 0">
                   <a :href="fileCiri2[0].url" target="_blank">
                     {{ fileCiri2[0].name }}
                   </a>
                   &nbsp;
                   <w-button
                     bg-color="error-dark1"
                     @click="deleteFile(fileCiri2[0].id)"
                   >
                     <w-icon xs>fal fa-trash</w-icon>
                   </w-button>
                 </template>

                 <span v-else>-</span>
               </td>

            </template>
             <z-select class="mt4" :items="status_mp" label="Status *"  v-model="form_s.lkp_status_id"  :validators="[validators.required]" readonly/>
            <w-textarea class="mt4"  label="Catatan *"  v-model="form_s.catatan" :validators="[validators.required]" v-if="form_s.lkp_status_id == 24"/>
            <w-textarea class="mt4"  label="Catatan"  v-model="form_s.catatan"  v-else/>

          
         </div>
        </div>
        <w-flex class="mt3" wrap align-center justify-end>
          <!-- <w-button class="my1" type="submit" :disabled="form_s.valid === false" :loading="form_s.submitted && !form_s.sent" @click="send(2)"> -->
          <w-button class="my1"   :loading="form_s.submitted && !form_s.sent" @click="send(2), onSuccess()">
              <w-icon dark tile class="mr2" >fal fa-save</w-icon> SIMPAN
          </w-button>&nbsp;
          <w-button class="my1" bg-color="success" type="submit" :disabled="form_s.valid === false" :loading="form_s.submitted && !form_s.sent" @click="send(1)">
              <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
          </w-button>
        </w-flex>
      </w-form>
	 </template>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'



export default {
  extends: ZResource,
  props: {
    d_data: [Array, Object],
    attahecment: [Array,Object],
    
  },
  data() {
    return {
     
      form_s : {
      	lkp_ternakan_id : '',
      	lkp_baka_id : '',
      	se_katalog_id : '',
      	se_pemungutan_id : '',
      	keputusan_id : '',
      	ujian_bakteria_id : '',
      	ujian_virus_id : '',
      	lkp_status_id : '',
         catatan : '',
         no_kes :'',
         hantar : 2
      	
      },
      data: this.d_data,
      status_mp : [],
      status_lg : [],
      attahecment : [],
      fileCiri2: [],
      
    }
  },
  methods: {
    send(hantar){
      this.form_s.hantar = hantar
    },
    onSuccess() {
        if (this.form_s.hantar == 1) {

          const adaNoKes =
            this.form_s.no_kes && this.form_s.no_kes.trim() !== '';

          const adaFile =
            (this.files && this.files.length > 0) ||
            (this.fileCiri2 && this.fileCiri2.length > 0);

          if (!adaNoKes && !adaFile) {
            this.$zutil.notify(
              'Sila isi No Kes ATAU muat naik fail PDF sebelum hantar',
              false
            );
            return;
          }

          if (adaNoKes) {
            this.$zcomm
              .get(this.api_service + 'check_integrasi/kes/' + this.form_s.no_kes, {})
              .then(res => {
                if (!res || res === null) {
                  this.$zutil.notify(
                    "No Kes tidak wujud, sila rujuk Myvetlab",
                    false
                  );
                } else {
                  this.hantarData();
                }
              });
          } else {
            this.hantarData();
          }

        } else {
          this.$zcomm.post('se.kawalan.store_saringan_penyakit', {
            lkp_ternakan_id: this.data.lkp_ternakan_id,
            lkp_baka_id: this.data.lkp_baka_id,
            se_katalog_id: this.data.se_katalog_id,
            se_pemungutan_id: this.data.id,
            keputusan_id: this.form_s.keputusan_id,
            ujian_bakteria_id: this.form_s.ujian_bakteria_id,
            ujian_virus_id: this.form_s.ujian_virus_id,
            lkp_status_id: this.form_s.lkp_status_id,
            no_kes: this.form_s.no_kes,
            catatan: this.form_s.catatan,
            attahecment: this.data.attahecment
          }).then(() => {
            this.uploadImg(this.data.id);
            this.$zutil.notify("Rekod telah berjaya disimpan");
            this.$inertia.visit(
              this.$route('se.kawalan.show', this.data.id) + '?t=2'
            );
          });
        }
      },

      hantarData() {
        this.$swal({
          title: 'Anda Pasti?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then(result => {
          if (result.value) {
            this.$zcomm.post('se.kawalan.store_saringan_penyakit', {
              lkp_ternakan_id: this.data.lkp_ternakan_id,
              lkp_baka_id: this.data.lkp_baka_id,
              se_katalog_id: this.data.se_katalog_id,
              se_pemungutan_id: this.data.id,
              keputusan_id: this.form_s.keputusan_id,
              ujian_bakteria_id: this.form_s.ujian_bakteria_id,
              ujian_virus_id: this.form_s.ujian_virus_id,
              lkp_status_id: this.form_s.lkp_status_id,
              no_kes: this.form_s.no_kes,
              catatan: this.form_s.catatan,
              attahecment: this.data.attahecment,
              hantar: 1
            }).then(() => {
              this.uploadImg(this.data.id);
              this.$zutil.notify("Rekod telah berjaya dihantar");
              this.$inertia.visit(
                this.$route('se.kawalan.show', this.data.id) + '?t=2'
              );
            });
          }
        });
      },

    deleteFile(id) {
     this.$swal({
       title: 'Anda pasti?',
       text: 'Fail PDF ini akan dipadam',
       type: 'warning',
       showCancelButton: true,
       confirmButtonText: 'Ya, padam',
       cancelButtonText: 'Batal'
     }).then(result => {
       if (result.value) {
         this.$zcomm
           .get(this.$route('attahecment.delete', id), {})
           .then(() => {
             this.$zutil.notify('Fail berjaya dipadam')
             this.getFileAttacmen()
             this.getAttahecment()
           })
       }
     })
   },

    lulus(){
      if(this.form_s.ujian_bakteria_id && this.form_s.ujian_virus_id){
         if (this.form_s.ujian_bakteria_id == 22 && this.form_s.ujian_virus_id == 22)
         {
            this.form_s.keputusan_id = 22;
            this.form_s.lkp_status_id = 25;
         }
         else
         {
            this.form_s.keputusan_id = 23;
            this.form_s.lkp_status_id = 24;
         }
      }


    },

    getStatusMp(){
      
      this.$zcomm.get(this.api_service + 'lookup/status_mp', {}).then(res => {
        this.status_mp = res
      })
    },

    getStatusLg(){
      
      this.$zcomm.get(this.api_service + 'lookup/status_lg', {}).then(res => {
        this.status_lg = res
      })
    },

    getData(){
      this.$zcomm.get(this.api_service + 'se_pemungutan/saringan_penyakit/'+this.data.id, {}).then(res => {
        if(res.s == 1){
          this.form_s = res
        }
      })
    },

    getAttahecment()
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : this.data.id, model : '\\App\\Model\\SeKawalan'}).then(res => {
        this.attahecment = res
        this.slides = [];
       for (var b in this.attahecment) {
          this.slides.push({title: this.attahecment[b].information, image: this.attahecment[b].url})
       }
      })
    },



   uploadImg(item) 
    {  
       let formData = new FormData();
       for (var b in this.files) 
       {
           formData.append("files["+b+"]", this.files[b].file);
       }
       formData.append("model",'\\App\\Model\\SeKawalan');
       formData.append("model_id", item);
       this.$zcomm.post('attahecment.upload_replace', formData)
           .then((res) => {
               this.getAttahecment();
           })
           .catch((err) => {})
           .finally(() => {});
   },
   
   deletelAttahecment(id)
   {
    if (confirm('Are you sure to delete this record?')) {
       this.$zcomm.get(this.$route('attahecment.delete', id), {})
       .then(res => {
        this.getAttahecment();
       })
     }
   },

   getFileAttacmen()
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : this.data.id, model : '\\App\\Model\\SeKawalan'}).then(res => {
        this.fileCiri2 = res
      })
    },

    url_kes(kes) {
      kes = kes.replace(/^\uFEFF+/, '').trim();
      this.$zcomm.get(this.api_service + 'integrasi/kes/'+kes, {}).then(res => {
          res.urls.forEach(url => {
             window.open(url, "_blank")
          })
    
      })
       .catch(err => {
            this.$zutil.notify("no_kes: Tiada dalam sistem MyVetLab", false);
            console.error(err);
        });
    },


    
  
  },

  watch: {

  },
  mounted() {
    
   	this.getStatusMp()
   	this.getStatusLg()
   	this.getData()
      this.getAttahecment()
      this.getFileAttacmen()
    
  }
    
}
</script>
